import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("商品卖点和培训资料");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("批量添加");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 返回 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 添加商品 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "20px"
  }
}, null, -1);

const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_8 = ["src"];
import { ref, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { batchAddMerInfo, checkProduct, getSellPointAndMaterialsList } from '@/request';
import { jsonStringify } from '@/utils';
import { useRouter, useRoute } from 'vue-router';
import AddProductModal from './component/AddProductModal.vue';
import MultipleInputList from './component/multiple-input.vue';
export default {
  name: 'BatchAddSellPointAndMaterials',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    onMounted(() => {
      let {
        prodNo
      } = route.query;

      if (prodNo) {
        getDetail(prodNo);
      }
    });

    function getDetail(prodNo) {
      getSellPointAndMaterialsList({
        page: 1,
        rows: 1,
        merKeyword: prodNo
      }).then(res => {
        let detailData = res.rows[0];
        let {
          brandName,
          prodAlias,
          merIntroduction,
          salesTalk,
          videoList,
          picList,
          supMerIntroductionId,
          prodName,
          prodSpecification,
          manufacture
        } = detailData;
        form.value = {
          brandName,
          prodAlias,
          merIntroduction,
          salesTalk,
          videoList: videoList.length ? videoList : [{
            name: '',
            link: ''
          }],
          supMerIntroductionId
        };
        fileList.value = picList.map(url => ({
          url
        }));
        productList.value = [{
          prodNo,
          prodName,
          prodSpecification,
          manufacture
        }];
      });
    }

    function goBack() {
      router.replace({
        name: route.query.from
      });
    }

    const imgSrc = require('./image/mer_introduction.png');

    const form = ref({
      brandName: '',
      prodAlias: '',
      merIntroduction: '',
      salesTalk: '',
      videoList: [{
        name: '',
        link: ''
      }],
      picList: []
    });
    const table = ref();
    const formRef = ref();
    const showAddProductModal = ref(false);
    const productList = ref([]);
    const tableOptions = {
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '商品编码',
        field: 'prodNo',
        width: '250px'
      }, {
        title: '商品名称',
        field: 'prodName',
        width: '250px'
      }, {
        title: '规格',
        field: 'prodSpecification',
        width: '150px',
        showOverflow: 'tooltip'
      }, {
        title: '厂家',
        field: 'manufacture',
        showOverflow: 'tooltip'
      }]
    };

    function selected(rows) {
      productList.value = productList.value.concat(rows);
    }

    function delProduct() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage({
          showClose: true,
          message: '请勾选商品后再进行操作!',
          type: 'warning'
        });
        return;
      }

      ElMessageBox.confirm(`是否确认删除${selectRows.length}条数据`, {
        title: '删除'
      }).then(() => {
        productList.value = productList.value.filter(prod => selectRows.every(row => row.prodNo !== prod.prodNo));
      });
    }

    function save() {
      form.value.picList = fileList.value.map(item => {
        if (item.response) {
          return item.response.data.picUrl;
        }

        return item.url;
      });

      if (!productList.value.length) {
        ElMessage({
          showClose: true,
          message: '请挑选商品后再进行操作!',
          type: 'warning'
        });
        return;
      }

      formRef.value.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (result) {
          if (result) {
            let chekcResult = yield checkProduct({}, {
              params: {
                datas: jsonStringify(productList.value.map(prod => prod.prodNo))
              }
            });

            if (!chekcResult.success) {
              yield ElMessageBox.confirm(chekcResult.message, {
                title: '提示',
                dangerouslyUseHTMLString: true
              });
            }

            let body = _objectSpread({}, form.value);

            body.videoList = form.value.videoList.filter(item => item.name || item.link);
            batchAddMerInfo(_objectSpread(_objectSpread({}, body), {}, {
              // datas: jsonStringify(productList.value.map((prod) => prod.prodNo)),
              datas: productList.value.map(prod => prod.prodNo),
              __repeat: true,
              __warn: true
            })).then(data => {
              if (data.success) {
                ElMessage({
                  showClose: true,
                  message: '添加成功!',
                  type: 'success'
                });
                goBack();
              }
            });
          }
        });

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    } // 图片上传


    const fileList = ref([]);
    const dialogImageUrl = ref('');
    const dialogVisible = ref(false);

    const handlePictureCardPreview = uploadFile => {
      dialogImageUrl.value = uploadFile.url;
      dialogVisible.value = true;
    };

    function handleBeforeUpload(file) {
      if (!/.(jp(e)?g|png|gif)$/.test(file.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png,gif格式的文件');
        return false;
      }

      return true;
    }

    const handleSuccess = res => {
      let {
        code,
        msg
      } = res;
      fileList.value = fileList.value.filter(file => {
        if (file.response) {
          return file.response.code === 1;
        }

        return true;
      });

      if (code !== 1) {
        ElMessage.error(msg);
      }
    };

    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_Plus = _resolveComponent("Plus");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "margin": "20px 0"
        },
        justify: "start"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Back",
          type: "primary",
          link: "",
          onClick: goBack
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 17
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "品牌名",
              prop: "brandName",
              rules: {
                required: true,
                message: '请输入品牌名'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.brandName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.brandName = $event),
                placeholder: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "别名"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.prodAlias,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.prodAlias = $event),
                placeholder: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "卖点"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                type: "teatarea",
                autosize: {
                  minRows: 4,
                  maxRows: 6
                },
                modelValue: form.value.merIntroduction,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.merIntroduction = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "产品优势"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                type: "teatarea",
                autosize: {
                  minRows: 4,
                  maxRows: 6
                },
                modelValue: form.value.salesTalk,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.salesTalk = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "视频资料"
            }, {
              default: _withCtx(() => [_createVNode(MultipleInputList, {
                modelValue: form.value.videoList,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.videoList = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "商品图文介绍"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_upload, {
                "file-list": fileList.value,
                "onUpdate:file-list": _cache[5] || (_cache[5] = $event => fileList.value = $event),
                action: "/basic/uploadFile.json",
                multiple: "",
                "list-type": "picture-card",
                "on-preview": handlePictureCardPreview,
                "before-upload": handleBeforeUpload,
                "on-success": handleSuccess
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_Plus)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["file-list"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5,
          offset: 2
        }, {
          default: _withCtx(() => [_createVNode(_component_el_image, {
            style: {
              "width": "200px",
              "height": "400px",
              "box-shadow": "0 0 10px #ccc"
            },
            src: _unref(imgSrc),
            "preview-src-list": [_unref(imgSrc)],
            fit: "cover"
          }, null, 8, ["src", "preview-src-list"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, tableOptions, {
        data: productList.value
      }), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Plus",
          type: "primary",
          onClick: _cache[6] || (_cache[6] = $event => showAddProductModal.value = true)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          icon: "Delete",
          onClick: delProduct
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        _: 1
      }, 16, ["data"]), _hoisted_6, _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        })]),
        _: 1
      }), _createVNode(AddProductModal, {
        modelValue: showAddProductModal.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showAddProductModal.value = $event),
        actProductList: productList.value,
        onSelected: selected
      }, null, 8, ["modelValue", "actProductList"]), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dialogVisible.value = $event),
        top: "5vh",
        width: "800px"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: dialogImageUrl.value,
          alt: "Preview Image",
          style: {
            "max-width": "760px",
            "margin": "0 auto"
          }
        }, null, 8, _hoisted_8)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};